import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage"; 
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBRwxqU4sNpsMj1N6fNBmQrv1Xwhhntc-A",
  authDomain: "rosemount-financial-solu-4f940.firebaseapp.com",
  projectId: "rosemount-financial-solu-4f940",
  storageBucket: "rosemount-financial-solu-4f940.appspot.com",
  messagingSenderId: "9919024994",
  appId: "1:9919024994:web:db3012f344f4445f94a63b",
  measurementId: "G-16YBEB2Z8J",
};


// const firebaseConfig = {
//   apiKey: "AIzaSyAUAScaVBp5fLzmd-XK9nRG1SBiprR3J_s",
//   authDomain: "rosemount-financial-solu-4f940.firebaseapp.com",
//   projectId: "rosemount-financial-solu-4f940",
//   storageBucket: "rosemount-financial-solu-4f940.appspot.com",
//   messagingSenderId: "9919024994",
//   appId: "1:9919024994:web:341936e0cdfd6dc894a63b",
// };


// Initialize Firebase app
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);

export { auth, db, storage };
